import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLogitechComponent } from './simple-icons-logitech.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLogitechComponent ],
    exports:      [ SimpleIconsLogitechComponent ],
    bootstrap:    []
})
export class SimpleIconsLogitechModule {}
